import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { authApi } from "@/lib/api";
import { AuthDialog } from "@/components/AuthDialog";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [dialog, setDialog] = useState({ open: false, reason: "", onDone: null });

  useEffect(() => { authApi.me().then(setUser).catch(() => setUser(false)); }, []);

  const openAuth = useCallback((reason = "", onDone = null) => setDialog({ open: true, reason, onDone }), []);
  const logout = async () => { await authApi.logout().catch(() => {}); setUser(false); };
  const handleAuthed = (u) => {
    setUser(u);
    const cb = dialog.onDone;
    setDialog({ open: false, reason: "", onDone: null });
    if (cb) cb(u);
  };

  return (
    <AuthContext.Provider value={{ user, openAuth, logout }}>
      {children}
      <AuthDialog open={dialog.open} reason={dialog.reason} onClose={() => setDialog({ open: false, reason: "", onDone: null })} onAuthed={handleAuthed} />
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
